import React from 'react'
import PropTypes from 'prop-types'

import BrandNumbers from '@/component/Primitive/Brand/component/BrandNumbers'

const BrandStatsWidget = ({ stats }) => {
  return <BrandNumbers statistics={stats} />
}

BrandStatsWidget.propTypes = {
  stats: PropTypes.array
}

export default BrandStatsWidget
